"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var cache = __importStar(require("./cache"));
var findValueByPath_1 = __importDefault(require("./findValueByPath"));
var EMPTY = "";
/**
 *
 * Creates a RegEx replacer function to use the corresponding values and tag style.
 * @param {object} values - The object containing values for replacement.
 * @param {RegExp} tagEdges - A regular expression pattern for matching the start or end of a tag.
 * @param {MissingPathCallback} onMissingPath - A callback function to handle missing tags.
 * @returns {RegExReplacer} A function that takes a tag and replaces it with a value.
 */
var tagReplacer = function (values, tagEdges, onMissingPath) {
    /**
     * Replaces a tag with its resolved value if found; otherwise, returns the tag.
     * @param {string} match The matched tag
     * @returns {string} The resolved value if the tag matches a path in the `values` object; otherwise, the original tag.
     */
    var replacer = function (match) {
        var path = match.replace(tagEdges, EMPTY);
        if (!cache.has(path))
            (0, findValueByPath_1.default)(values, path);
        return cache.getString(path, match, onMissingPath);
    };
    return replacer;
};
exports.default = tagReplacer;
